/**
 * Shared mutations between components.
 */

/**
 * Adds provided id's to the component's `trackedErrors` list.
 * @param {*} state The component state
 * @param {Array} payload The list of id's to add
 */
export const ADD_TRACKED_ERRORS = (state, payload) => {
    for (let item of payload.entries()) {
        const id = item[1];
        if (state.trackedErrors.indexOf(id) === -1) {
            state.trackedErrors.push(id);
        }
    }
};

/**
 * Removes provided id's from the component's `trackedErrors` list.
 * @param {*} state The component state
 * @param {*} payload The list of id's to remove
 */
export const REMOVE_TRACKED_ERRORS = (state, payload) => {
    for (let item of payload.entries()) {
        const id = item[1];
        let index = state.trackedErrors.indexOf(id);
        if (index > -1) {
            state.trackedErrors.splice(index, 1);
        }
    }
};